export const getFormData = () => {
  return {
    /** 安全区域名称 */
    pathName:'',
    /** 安全区域类型1-政府部门2-机场3-火车站4-客运站 */
    pathType:1,
    /** 状态0-出区域，1-入区域2-限停3-运力不足4-跨区域 */
    status:1,
    /** 区域形状1-多边形2-圆形 */
    regionShape:1,
    /** 车辆数--状态为运力不足时，传值 */
    number:null,
    /** 设置的报警时间 */
    settingTime:null,
    /** 经度--状态为运力不足或者区域形状是圆形时，传值 */
    lon:null,
    /** 纬度--状态为运力不足或者区域形状是圆形时，传值 */
    lat:null,
    /** 半径（km）--状态为运力不足或者区域形状是圆形时，传值 */
    radius:null,
    /** 预警车辆数（运力不足传） */
    earlyWarnNumber:null,
    /** 预警限停时间（限停独有） */
    earlyWarnLimitStopTime:null,
    /** 是否启动 */
    enabled:1,
    /** 备注 */
    remark:'',
    /** 围栏所属的位置点集合(进出区域、限停时且形状是多边形时传) */
    pointList:[],
  }
}
